import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div style={{ padding: 20, fontFamily: 'monospace', color: '#EF4444', whiteSpace: 'pre-wrap', fontSize: 12 }}>
          <h2 style={{ color: '#EF4444' }}>Render error</h2>
          <div><strong>{this.state.error.name}:</strong> {this.state.error.message}</div>
          <pre style={{ marginTop: 12, color: '#F59E0B', fontSize: 11, overflow: 'auto' }}>
            {this.state.error.stack}
          </pre>
          <button onClick={() => this.setState({ error: null })} style={{ marginTop: 12 }}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
